/**
 * Header Draggable Mixin
 *
 * Provides header drag functionality to enable dragging the popover window.
 * Components using this mixin must have an `isFullscreen` prop.
 *
 * Usage:
 *   import headerDraggable from '@/components/OliverBotV2/mixins/headerDraggable.js'
 *
 *   export default {
 *     mixins: [headerDraggable],
 *     props: {
 *       isFullscreen: {
 *         type: Boolean,
 *         default: false
 *       }
 *     }
 *   }
 *
 *   // In template:
 *   <div @mousedown="handleHeaderDrag" @touchstart="handleHeaderDrag">
 *     Drag me
 *   </div>
 *
 * Events Emitted:
 *   - 'start-popover-drag': Emitted when drag starts (only when not in fullscreen)
 */
export default {
  methods: {
    /**
     * Handle header drag to move popover.
     * Only works when not in fullscreen mode.
     *
     * Calls preventDefault on mousedown and clears any active text selection
     * so the browser's native "drag the selected text" behavior doesn't
     * hijack the popover drag when the user has text highlighted (either
     * inside the modal or on the page behind it).
     * @param {Event} event - Mouse or touch event
     */
    handleHeaderDrag(event) {
      if (this.isFullscreen || this.isDocked) return;

      if (event.type === "mousedown") {
        event.preventDefault();
      }

      const selection = window.getSelection && window.getSelection();
      if (selection && !selection.isCollapsed) {
        selection.removeAllRanges();
      }

      this.$emit("start-popover-drag", event);
    },
  },
};
